<div class="container-fluid">
    <div class="pb-wrapper">
        <div class="tab-content" *ngIf="showPropertyFlag">
            <ng-container [ngSwitch]="propertyView">
            <app-companyinfo *ngSwitchCase="1" (formChange)="changeFormStatus($event)" (showNextPage)="openPage($event)"></app-companyinfo>
            <app-companyimages *ngSwitchCase="2" (formChange)="changeFormStatus($event)" (showNextPage)="openPage($event)"></app-companyimages>
        </ng-container>

        </div>
    </div>
</div>